export default {
    state: {
        loginmodal: true,
    },
    getters: {
        loginmodal: (state) => state.loginmodal,
    },
    actions: {
        SET_LOGIN_MODAL({ commit }, payload) {
            commit("SET_LOGIN_MODAL", payload);
        },
    },
    mutations: {
        SET_LOGIN_MODAL(state, payload) {
            state.loginmodal = payload;
        },
    },
};
